export default "__VITE_ASSET__CmFrNXpy__"